(function(){
  /* mobile menu */
  var m = document.querySelector('.g7-menu'), nav = document.getElementById('g7nav');
  if (m && nav) m.addEventListener('click', function(){ var o = nav.classList.toggle('open'); m.setAttribute('aria-expanded', o); });
  /* mark current nav item */
  document.querySelectorAll('.g7-nav a').forEach(function(a){ if (a.pathname === location.pathname) a.setAttribute('aria-current', 'page'); });
  /* measurement: dataLayer + Shopify custom events (no third-party script is loaded here) */
  window.dataLayer = window.dataLayer || [];
  function track(name, data){
    try { window.dataLayer.push(Object.assign({event: name, page_language: document.documentElement.lang}, data || {})); } catch(e){}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch(e){}
  }
  window.g7track = track;
  document.addEventListener('click', function(e){
    var a = e.target.closest && e.target.closest('a[href]'); if (!a) return;
    var h = a.getAttribute('href') || '';
    if (/^https?:\/\/(wa\.me|api\.whatsapp\.com)/.test(h)) track('whatsapp_click', {link_url: h});
    else if (h.indexOf('tel:') === 0) track('phone_click', {link_url: h});
    else if (h.indexOf('mailto:') === 0) track('email_click', {link_url: h});
  });
  /* forms: honeypot + submit tracking + successful lead event */
  document.querySelectorAll('form.g7-form[data-g7-service]').forEach(function(f){
    f.addEventListener('submit', function(e){
      var hp = f.querySelector('input[name="contact[Website]"]');
      if (hp && hp.value){ e.preventDefault(); return; }
      var b = f.querySelector('button[type="submit"]'); if (b){ setTimeout(function(){ b.disabled = true; }, 0); }
      track('lead_form_submit', {service: f.getAttribute('data-g7-service') || 'general'});
    });
  });
  var ok = document.querySelector('[data-g7-lead]');
  if (ok){ track('generate_lead', {service: ok.getAttribute('data-g7-lead')}); ok.scrollIntoView({block: 'center'}); }
  /* shop quote drawer: count a successful request as a lead */
  var dl = document.getElementById('drList');
  if (dl && 'MutationObserver' in window){ new MutationObserver(function(){ if (dl.querySelector('.dr-done') && !dl.dataset.g7lead){ dl.dataset.g7lead = '1'; track('generate_lead', {service: 'shop-quote-request'}); } }).observe(dl, {childList: true}); }
  /* hide contact buttons that have no destination yet (no WhatsApp number / social URLs configured) */
  function g7hideEmpty(){
    var go = document.getElementById('waGo'), fab = document.getElementById('waFab');
    if (fab && (!go || !go.getAttribute('href') || go.getAttribute('href') === '#')) fab.hidden = true;
    document.querySelectorAll('a.soc').forEach(function(a){ if (a.getAttribute('href') === '#') a.hidden = true; });
    var socs = document.querySelector('.socs'); if (socs && !socs.querySelector('a.soc:not([hidden])') && socs.parentElement) socs.parentElement.hidden = true;
  }
  g7hideEmpty(); window.addEventListener('load', g7hideEmpty);
  /* product gallery thumbnails */
  document.querySelectorAll('.g7-thumbs img').forEach(function(t){ t.addEventListener('click', function(){ var main = document.getElementById('g7main-img'); if (main){ main.src = t.dataset.full; main.alt = t.alt; } }); });
})();
